module.exports = __webpack_public_path__ + "static/img/netshoes-logo.57a57c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/netshoes-logo.jpg
// module id = 224
// module chunks = 6